<template>
  <div class="nav-left-box">
    <h1 class="title" v-if="!fold" @click="toHome">管理台</h1>
    <div class="el-icon-bell top-icon"  v-else></div>
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#001529"
      text-color="#fff"
      active-text-color="#ffd04b"
      :router="true"
      :collapse="fold"
    >
      <div v-for="(item, index) in menuData" :key="index">
        <!-- 有子页面的情况 -->
        <el-submenu v-if="item.menuInfoList" :index="item.jump">
          <template slot="title">
            <span v-if="!fold" slot="title">{{item.title}}</span>
          </template>
          <el-menu-item v-for="(itemChild, childIndex) in item.menuInfoList" :key="childIndex" :index="itemChild.jump">
            <i :class="itemChild.icon"></i>
            <span slot="title">{{itemChild.title}}</span>
          </el-menu-item>
        </el-submenu>
        <!-- 没有子页面的情况 -->
        <el-menu-item v-else :index="item.jump">
          <template slot="title">
            <span v-if="!fold" slot="title">{{item.title}}</span>
          </template>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
import menus from "./menu";
export default {
  components: {
    menus
  },
  props: {
    fold: {
      type: Boolean,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      // 路由菜单
      menuData: []
    };
  },
  mounted() {
    this.getList()
  },
  methods:{
    toHome() {
      this.$router.push({path:'/instrumentsPanel/list'})
    },
    /**
     * 获取菜单列表
     */
    getList() {
      // let data = {
      //   platform:1
      // }
      this.$api.Login.getManageInfo().then(res =>{
        console.log(res,'45')
        this.menuData = res.data.data
        console.log(this.menuData)
        // 将接口返回的route列表全部储存到store
        this.$store.commit('saveRoute', res.data.data)
        localStorage.setItem('routeList', JSON.stringify(res.data.data))
      })
    }
  },
  components: {
  }
};
</script>

<style  scoped>
.title {
  line-height: 50px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.nav-left-box{
  height: 100%;
  overflow-x: hidden;
}
.nav-left-box::-webkit-scrollbar{
  display: none;
}
.el-menu-vertical-demo{
  height: 100%;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 64px;
}
.top-icon{
  display: block;
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/navLeft.vue